// extracted by mini-css-extract-plugin
export default {"foldername":"threeDStyles_foldername__nm-GV","card":"threeDStyles_card__8WC8O","create_sec":"threeDStyles_create_sec__8FWHb","create_text":"threeDStyles_create_text__XAcxS"};